/**
 * Input manager - Device detection and provider coordination
 */

import type { InputProvider, DeviceType } from "@game/domain";
import { KeyboardMouseInput } from "./KeyboardMouseInput";
import { TouchInput } from "./TouchInput";

/**
 * Detect device type
 */
export function detectDeviceType(): DeviceType {
  return "ontouchstart" in window ? "mobile" : "desktop";
}

/**
 * Create input provider for device
 */
export function createInputProvider(
  deviceType: DeviceType,
  canvas: HTMLCanvasElement,
): InputProvider {
  if (deviceType === "mobile") {
    return new TouchInput(canvas);
  }
  return new KeyboardMouseInput(canvas);
}
